import React, { useState, useEffect } from "react";
import { useScreenSize, useCustomScreen } from "../Utils";

const serveItems = [
  {
    id: 1,
    name: "Roofers",
    image: "/images/Roofers.png",
  },
  {
    id: 2,
    name: "Contractors",
    image: "/images/Contractors.png",
  },
  {
    id: 3,
    name: "Insurance Adjusters",
    image: "/images/InsuranceAdjusters.png",
  },
  {
    id: 4,
    name: "Insurance Carriers",
    image: "/images/InsuranceCarriers.png",
  },
];

export default function ServeSection() {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isLandscape1024, isPortrait1024, isIpadProPortrait } =
    useCustomScreen();
  const devicePixelRatio = window.devicePixelRatio;

  return (
    <section
      id="appointment"
      style={{
        height: isSmallScreen
          ? "auto"
          : isXlScreen && devicePixelRatio >= 1.5
          ? "50vh"
          : isXlScreen
          ? "50vh"
          : window.innerWidth > 1200 && window.innerWidth < 1300
          ? "50vh"
          : window.innerWidth > 1300 && window.innerWidth < 2000
          ? "50vh"
          : "50vh",
      }}
      className="appointment"
    >
      <div>
        <header className="section-header ">
          <h3
            style={{
              fontSize: is4kScreen
                ? "5.3rem"
                : isXxlScreen
                ? "2.8rem"
                : isXlScreen
                ? "2.6rem"
                : isIpadProPortrait
                ? "3rem"
                : isLargeScreen
                ? "2.2rem"
                : isMediumScreen
                ? "2.4rem"
                : isSmallScreen
                ? "2rem"
                : "2rem",
            }}
          >
            We proudly serve…
          </h3>
        </header>
      </div>
      <div className="container position-relative">
        <div className="row">
          {serveItems.map((item) => {
            const { id, name, image } = item;
            return (
              <div
                className="col-xl-3 col-md-6 align-items-stretch mb-5"
                key={id}
              >
                {/* <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "" }}
                >
                  <div
                    className="position-relative text-center bg-white p-4  shadow"
                    style={{ width: "100%", height: "250px" }}
                  >
                    {/* Circular icon */}
                {/* <div
                      className="position-absolute top-0 start-50 translate-middle"
                      style={{
                        width: is4kScreen ? "170px" : "80px",
                        height: is4kScreen ? "170px" : "80px",
                        borderRadius: "50%",
                        backgroundColor: "#007BFF",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "hidden",
                        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                      }}
                    >
                      <img
                        src={image}
                        alt={name}
                        style={{
                          width: "70%",
                          height: "70%",
                          objectFit: "contain",
                        }}
                      />
                    </div>

                    <div style={{ marginTop: is4kScreen ? "5rem" : "2rem" }}>
                      <h5
                        style={{ fontStyle: is4kScreen ? "1.3rem" : "" }}
                        className="mt-4"
                      >
                        {name}
                      </h5>
                    </div>
                  </div>
                </div> */}

                <div className="d-flex justify-content-center align-items-center">
                  <div
                    className="server-container"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      height: "30vh",
                      width: "50vh",
                    }}
                  >
                    <div
                      className=""
                      style={{
                        height: isSmallScreen
                          ? "100px"
                          : isMediumScreen
                          ? "130px"
                          : isLargeScreen && isPortrait1024
                          ? "140px"
                          : isLargeScreen
                          ? "100px"
                          : isXlScreen
                          ? ""
                          : isXxlScreen
                          ? "120px"
                          : "180px",
                        width: isSmallScreen
                          ? "100px"
                          : isMediumScreen
                          ? "130px"
                          : isLargeScreen && isPortrait1024
                          ? "140px"
                          : isLargeScreen
                          ? "100px"
                          : isXlScreen
                          ? ""
                          : isXxlScreen
                          ? "120px"
                          : "180px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "50%",
                        backgroundColor: "rgb(186, 229, 236)",
                      }}
                    >
                      <img
                        src={image}
                        alt={name}
                        style={{
                          height: isSmallScreen
                            ? "90px"
                            : isMediumScreen
                            ? "115px"
                            : isLargeScreen && isPortrait1024
                            ? "130px"
                            : isLargeScreen
                            ? "90px"
                            : isXlScreen
                            ? ""
                            : isXxlScreen
                            ? "110px"
                            : "150px",
                          width: isSmallScreen
                            ? "90px"
                            : isMediumScreen
                            ? "115px"
                            : isLargeScreen && isPortrait1024
                            ? "130px"
                            : isLargeScreen
                            ? "90px"
                            : isXlScreen
                            ? ""
                            : isXxlScreen
                            ? "110px"
                            : "150px",
                        }}
                      />
                    </div>
                    <h4
                      style={{
                        fontSize: is4kScreen
                          ? "2.6rem"
                          : isXxlScreen
                          ? "1.6rem"
                          : isXlScreen
                          ? "1.3rem"
                          : isLargeScreen && isPortrait1024
                          ? "2.1rem"
                          : isLargeScreen
                          ? "1.2rem"
                          : isMediumScreen
                          ? "1.5rem"
                          : "1.3rem",
                        paddingTop: isSmallScreen
                          ? "1rem"
                          : isMediumScreen
                          ? "1rem"
                          : isLargeScreen && isPortrait1024
                          ? " 1rem"
                          : isLargeScreen
                          ? "1rem"
                          : isXlScreen
                          ? "1rem"
                          : isXlScreen
                          ? "1rem"
                          : isXxlScreen
                          ? "1.25rem"
                          : is4kScreen
                          ? "2rem"
                          : "0",
                      }}
                    >
                      {name}
                    </h4>
                  </div>
                </div>

                {/* <div
                  className=" server-container"
                  style={{ minHeight: "20vh" }}
                >
                  <div className="icon" style={{}}>
                    <i style={{ background: "#7AC6D2", borderRadius: "50px" }}>
                      <img src={image} alt={name} />
                    </i>
                  </div>
                  <h4
                    style={{
                      fontSize: is4kScreen
                        ? "3rem"
                        : isXxlScreen
                        ? "1.4rem"
                        : isXlScreen
                        ? "1.3rem"
                        : isLargeScreen
                        ? "1.2rem"
                        : "25px",
                    }}
                  >
                    {name}
                  </h4>
                </div> */}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
